/**
 * Brysa: inline color swap for sibling-product swatches (custom.cores metafield).
 * Each color is a separate product, so the stock Halo handler can't resolve it
 * as a variant; capture phase stops it from setting a foreign ?variant= href.
 */
(function () {
  document.addEventListener(
    'click',
    function (event) {
      var label = event.target.closest('.swatch-label[data-sibling-url]');
      if (!label) return;

      event.preventDefault();
      event.stopPropagation();

      var card = label.closest('.product-item') || label.closest('.card-product') || label.closest('.card');
      if (!card) return;

      var swatch = label.closest('.swatch');
      if (swatch) {
        swatch.querySelectorAll('.swatch-label').forEach(function (el) {
          el.classList.remove('is-active');
        });
      }
      label.classList.add('is-active');

      var img = label.getAttribute('data-sibling-img');
      var hoverImg = label.getAttribute('data-sibling-img-hover') || img;
      if (img) {
        card.querySelectorAll('.card-media img').forEach(function (el, i) {
          el.removeAttribute('srcset');
          el.removeAttribute('data-srcset');
          el.src = i === 0 ? img : hoverImg;
        });
      }

      var url = label.getAttribute('data-sibling-url');
      if (url) {
        card
          .querySelectorAll('a[href]:not(.single-action):not(.number-showmore)')
          .forEach(function (a) {
            a.setAttribute('href', url);
          });
      }

      var price = label.getAttribute('data-sibling-price');
      var compare = label.getAttribute('data-sibling-compare-price');
      var priceBox = card.querySelector('.card-price');
      if (price && priceBox) {
        var saleEl = priceBox.querySelector('.price__sale .price-item--sale');
        var regularSaleEl = priceBox.querySelector('.price__sale .price-item--regular');
        var regularEl = priceBox.querySelector('.price__regular .price-item');
        var priceRoot = priceBox.querySelector('.price');
        if (compare && saleEl) {
          if (priceRoot) priceRoot.classList.add('price--on-sale');
          saleEl.innerHTML = price;
          if (regularSaleEl) regularSaleEl.innerHTML = compare;
        } else if (regularEl) {
          if (priceRoot) priceRoot.classList.remove('price--on-sale');
          regularEl.innerHTML = price;
          if (regularSaleEl) regularSaleEl.innerHTML = '';
        }
      }
    },
    true
  );
})();
